import { useContext } from 'react';
import { ArticleContext } from '../../Article.context';

export const VirtualCaption = ({ content = '', style = {} }: CaptionProps) => {
	const { lang } = useContext(ArticleContext);
	let text = '';
	if (typeof content === 'string') {
		text = content;
	} else if (typeof content === 'object') {
		text = content[lang];
	}
	if (!text.length) {
		return null;
	}

	if (!style) {
		style = {};
	}
	return (
		<figcaption className="imagecaption" style={style}>
			<p dangerouslySetInnerHTML={{ __html: text }} />
		</figcaption>
	);
};

interface CaptionProps {
	content: string;
	style?: any;
}
